export default "__VITE_ASSET__eHs0zvoX__"